{
  "version": 1,
  "asset_id": "9d71a005-e653-4378-b7b3-bd21087a9d36",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/9d71a005-e653-4378-b7b3-bd21087a9d36/appliances-hero.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/9d71a005-e653-4378-b7b3-bd21087a9d36/appliances-hero.webp",
  "original_filename": "appliances-hero.webp",
  "size": 77142,
  "content_type": "image/webp",
  "created_at": "2026-06-27T00:30:00Z"
}
